import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const CircleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.error.light,
  marginBottom: theme.spacing(3),
  borderRadius: '50%',
  width: '80px',
  height: '80px',
}));

export const StyledLockIcon = styled('div')({
  color: '#fff',
});

export const TextContainer = styled('div')({
  textAlign: 'center',
  lineHeight: 2,
});
